import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"
import { usePaymentTypeActions } from "../../../actions/paymentTypeActions"
import { PaymentCategory, PaymentType } from "../../../state/types"

export const useActions = () => {
    const { savePaymentType } = usePaymentTypeActions()
    
    const submitPaymentType = async (
        paymentTypeData: Data,
        adjustmentYield: number,
        financialCost: number,
        accreditationDays: number,
        cashFundsData: Data[],
        roundingEnabled: boolean,
        maxRoundingAmount: number | undefined,
        disabled: boolean,
        createMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const { companyId, id, name, category } = paymentTypeData
        const cashFundIds = cashFundsData.map(cashFundData => define(cashFundData.cashFundId) as string)
        const paymentType: PaymentType = {
            companyId: define(companyId) as string,
            id: define(id) as string,
            name: define(name) as string,
            category: define(category) as PaymentCategory,
            yield: adjustmentYield,
            financialCost,
            accreditationDays,
            cashFundIds,
            roundingEnabled,
            maxRoundingAmount: roundingEnabled ? maxRoundingAmount : undefined,
            disabled
        }

        await savePaymentType(paymentType)
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitPaymentType
    }
}
